import {
  CREATE_PVS_CATEGORY_REQUEST,
  CREATE_PVS_CATEGORY_SUCCESS,
  CREATE_PVS_CATEGORY_FAILURE,
  RESET_PVS_CATEGORY_STATE,
} from '../../../types/pvs';

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
};

const createPvsCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PVS_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      };

    case CREATE_PVS_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload?.message || "Category created successfully",
      };

    case CREATE_PVS_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
        message: action.payload?.message || "Failed to create subcategory", // ✅ Message for UI
      };

    case RESET_PVS_CATEGORY_STATE:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default createPvsCategoryReducer;
